/* Mobile menu drawer: open/close, focus trap-lite, Esc to close,
   body scroll lock while open. */
(function () {
  function init(drawer) {
    var openers = document.querySelectorAll('[data-drawer-open="' + drawer.id + '"]');
    var closers = drawer.querySelectorAll('[data-drawer-close]');
    var panel = drawer.querySelector('.drawer__panel');
    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var first = panel && panel.querySelector('a, button');
      if (first) first.focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocused) lastFocused.focus();
    }

    openers.forEach(function (el) { el.addEventListener('click', open); });
    closers.forEach(function (el) { el.addEventListener('click', close); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // Leaving mobile with the drawer open would strand it — and the scroll lock.
    var mq = window.matchMedia('(max-width: 859px)');
    var onChange = function () {
      if (!mq.matches && drawer.classList.contains('is-open')) close();
    };
    mq.addEventListener ? mq.addEventListener('change', onChange) : mq.addListener(onChange);
  }

  document.querySelectorAll('[data-drawer]').forEach(init);

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-drawer]').forEach(init);
  });
})();
